// @flow

import React, { type Node } from 'react';
import { Separator } from '../../../../../commons/atoms';

import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { CashTicket } from '../cash-ticket';
import { SaveAsPdfButton } from './save-as-pdf-button';
import { EfectyMapLink } from './efecty-map-link';
import { EfectyTipsBox } from './efecty-tips-box';
import { EfectyPaymentIntructions } from './efecty-payment-instructions';

export function EfectyPendingPage(): Node {
  const allFeatures = useAllFeatures();

  return (
    <>
      <p>Usa los siguientes datos para completar tu compra:</p>

      <CashTicket allFeatures={allFeatures} />

      <Separator pattern="dotted" />

      <EfectyPaymentIntructions />

      <EfectyMapLink />

      <SaveAsPdfButton />

      <EfectyTipsBox />
    </>
  );
}
